import React, { useState, useEffect } from "react";
import { QuestionnairePageTextPanel } from "./QuestionnairePageTextPanel";
import { QuestionnairePageListPanel } from "./QuestionnairePageListPanel";
import { QuestionnairePageImagePanel } from "./QuestionnairePageImagePanel";
import { QuestionnairePageLinkPanel } from "./QuestionnairePageLinkPanel";
import { QuestionnairePageBrowserPopupPanel } from "./QuestionnairePageBrowserPopupPanel";

export const QuestionnairePagePanels = ({ panels }) => {
	const [qPanels, setQPanels] = useState();
	useEffect(() => {
		if (panels) {
			setQPanels(panels);
		}
	}, [panels]);

	if (!qPanels) {
		return <></>;
	}

	return (
		<>
			{qPanels.map((p, i) =>
				p.isList ? (
					<QuestionnairePageListPanel
						key={`panel_${i}`}
						text={p.text}
						hasBackground={p.hasBackground}
						hasBorder={p.hasBorder}
						isCentered={p.isCentered}
						classes={p.classes}
					/>
				) : p.isBrowserPopup ? (
					<QuestionnairePageBrowserPopupPanel
						key={`panel_${i}`}
						text={p.text}
						hasBackground={p.hasBackground}
						hasBorder={p.hasBorder}
						isCentered={p.isCentered}
						classes={p.classes}
						url={p.urlLink || p.url}
						caption={p.caption}
					/>
				) : p.isImage ? (
					<QuestionnairePageImagePanel
						key={`panel_${i}`}
						caption={p.caption}
						alt={p.alt}
						hasBackground={p.hasBackground}
						hasBorder={p.hasBorder}
						isCentered={p.isCentered}
						classes={p.classes}
						imageClasses={p.imageClasses}
						url={p.url}
						urlLink={p.urlLink}
						popup={p.popup}
					/>
				) : p.isLink ? (
					<QuestionnairePageLinkPanel
						key={`panel_${i}`}
						hasBackground={p.hasBackground}
						hasBorder={p.hasBorder}
						isCentered={p.isCentered}
						classes={p.classes}
						urlLink={p.urlLink}
						text={p.text}
						popup={p.popup}
						caption={p.caption}
					/>
				) : (
					<QuestionnairePageTextPanel
						key={`panel_${i}`}
						text={p.text}
						hasBackground={p.hasBackground}
						hasBorder={p.hasBorder}
						isCentered={p.isCentered}
						classes={p.classes}
					/>
				)
			)}
		</>
	);
};
